/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start typing the highlighted text — the timer starts on your first keystroke. Correct characters turn light and mistakes turn red. When the time runs out, your WPM and accuracy are shown.`)
};

const es_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza a escribir el texto resaltado — el cronómetro arranca con tu primera pulsación. Los caracteres correctos se iluminan y los errores se marcan en rojo. Cuando se acaba el tiempo, se muestran tu WPM y tu precisión.`)
};

const de_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginne, den hervorgehobenen Text zu tippen — der Timer startet bei deinem ersten Tastendruck. Korrekte Zeichen werden hell, Fehler werden rot markiert. Wenn die Zeit abgelaufen ist, werden deine WPM und Genauigkeit angezeigt.`)
};

const nl_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin met het typen van de gemarkeerde tekst — de timer start bij je eerste toetsaanslag. Correcte tekens worden licht en fouten worden rood. Als de tijd om is, worden je WPM en nauwkeurigheid getoond.`)
};

const fr_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez à taper le texte en surbrillance — le chronomètre démarre à votre première frappe. Les caractères corrects s'éclaircissent et les erreurs deviennent rouges. Quand le temps est écoulé, votre WPM et votre précision s'affichent.`)
};

const it_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia a digitare il testo evidenziato — il timer parte al primo tasto premuto. I caratteri corretti diventano chiari e gli errori diventano rossi. Allo scadere del tempo, vengono mostrati il tuo WPM e la precisione.`)
};

const pt_br2_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece a digitar o texto destacado — o cronômetro começa na sua primeira tecla. Os caracteres corretos ficam claros e os erros ficam vermelhos. Quando o tempo acabar, seu WPM e precisão são exibidos.`)
};

const pt_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece a escrever o texto destacado — o cronómetro inicia na primeira tecla. Os caracteres corretos ficam claros e os erros ficam vermelhos. Quando o tempo terminar, são mostrados o seu WPM e precisão.`)
};

const ja_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハイライトされたテキストの入力を開始してください — タイマーは最初のキー入力でスタートします。正しく入力した文字は明るい色に、間違えた文字は赤色になります。時間が終了すると、WPMと正確率が表示されます。`)
};

const zh_typing_variant_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始输入高亮显示的文本 — 计时器会在您第一次按键时启动。正确的字符会变亮，错误的字符会变红。时间结束后，将显示您的WPM和准确率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_variant_howto = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_variant_howto(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_variant_howto", locale)
	if (locale === "en") return en_typing_variant_howto(inputs)
	if (locale === "es") return es_typing_variant_howto(inputs)
	if (locale === "de") return de_typing_variant_howto(inputs)
	if (locale === "nl") return nl_typing_variant_howto(inputs)
	if (locale === "fr") return fr_typing_variant_howto(inputs)
	if (locale === "it") return it_typing_variant_howto(inputs)
	if (locale === "pt-BR") return pt_br2_typing_variant_howto(inputs)
	if (locale === "pt") return pt_typing_variant_howto(inputs)
	if (locale === "ja") return ja_typing_variant_howto(inputs)
	return zh_typing_variant_howto(inputs)
};